import ShadowWrapper from "components/Common/ShadowWrapper";


const TermsV20260601 = () => {
  const htmlContent = `
    <!DOCTYPE html>
<html lang="ko">
  <head>
    <meta charset="UTF-8" />
    <title>파수에이아이 클라우드 서비스 통합 이용약관</title>
    <style>
      html,
      body,
      div,
      span,
      object,
      iframe,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      blockquote,
      pre,
      abbr,
      address,
      cite,
      code,
      del,
      dfn,
      em,
      img,
      ins,
      kbd,
      q,
      samp,
      small,
      strong,
      sub,
      sup,
      var,
      b,
      i,
      a,
      dl,
      dt,
      dd,
      fieldset,
      form,
      label,
      legend,
      table,
      caption,
      tbody,
      tfoot,
      thead,
      tr,
      th,
      td,
      article,
      aside,
      canvas,
      details,
      figcaption,
      figure,
      footer,
      header,
      hgroup,
      menu,
      nav,
      section,
      summary,
      time,
      mark,
      audio,
      video {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        text-decoration: none;
      }
      table {
        border-collapse: collapse;
        width: 100%;
      }
      body {
        font-family: "Noto Sans KR", Sans-serif;
      }
      h1 {
        font-size: 24px;
        text-align: center;
        padding: 20px 0;
      }
      .data-tb {
        width: 90%;
        margin: 20px auto;
      }
      .data-tb table,
      .data-tb th,
      .data-tb td {
        border: 1px solid #ececec;
        font-size: 14px;
      }
      .data-tb th {
        padding: 10px;
        background-color: rgba(185, 185, 185, 0.08);
      }
      .data-tb td {
        padding: 12px 20px;
        font-size: 12px;
        vertical-align: top;
      }

      .data-tb table th.color {
        font-weight: bold;
        background-color: rgba(61, 219, 135, 0.08);
      }

      .data-tb table th.color-yellow {
        font-weight: bold;
        background-color: rgba(242, 255, 125, 0.08);
      }
      ul {
        list-style-type: none;
      }

      ul,
      ol {
        padding-inline-start: 20px;
      }
        li {
        color: #797b82;
        margin-top:10px;
        font-size:14px;
        }
        .title {
    margin-top: 50px;
    margin-bottom: 13px;
    font-size: 22px;
    color: #28292b;
}
      .contents {
          margin-top: 10px;
    font-size: 14px;
    color: #797b82;
    line-height: 150%;
      }
    </style>
  </head>
  <body>
    <h1 >파수에이아이 클라우드 서비스 통합 이용약관</h1>
    <h2>제1장 총칙</h2>
    <h3 class="title">제1조 (목적)</h3>
    <p class="contents">
      본 약관은 주식회사 파수에이아이(이하 “회사”)에서 제공하는 클라우드 서비스(Wrapsody, Wrapsody eCo, Mind-SAT, Fireside, Fasoo DSP, Fasoo DSPM 등, 이하 “서비스”) 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
    </p>
    <h3 class="title">제2조 (용어의 정의)</h3>
    <p class="contents">본 약관에서 사용되는 용어의 정의는 다음과 같습니다.</p>
    <ul>
      <li>
        1. 서비스: 회원이 컴퓨터, 휴대용 단말기 등 각종 유·무선 기기를 통해
        이용할 수 있도록 회사가 제공하는 모든 클라우드 기반 인터넷 서비스를
        말합니다.
      </li>
      <li>
        2. 회원: 본 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는
        고객을 말합니다.
      </li>
      <li>
        3. 사이트: 서비스를 제공하는 웹 기반 홈페이지(https://*.wrapsody.com,
        https://cloud.wrapsody.com, https://*.wrapsodyeco.com,
        https://cloud.wrapsodyeco.com/*, https://cloud.mind-sat.com,
        https://*.fireside.fasoo.ai, https://*.fasoodsp.com 등) 및 관련 애플리케이션을 포함합니다.
      </li>
      <li>
        4. 아이디(ID): 회원의 식별 및 서비스 이용을 위해 회원이 입력한
        이메일(전자메일) 주소 또는 문자 조합을 의미합니다.
      </li>
      <li>
        5. 비밀번호(PASSWORD): 회원이 설정한 8자리 이상의 문자, 숫자, 특수문자
        조합으로 아이디와 연동되어 회원을 식별하는 보안수단을 의미합니다.
      </li>
      <li>
        6. 게시물: 회원이 사이트 내에 등록하는 모든 디지털 콘텐츠를 말합니다.
      </li>
      <li>
        7. 운영자: 서비스의 전반적인 관리와 원활한 운영을 위해 회사가 지정한
        자를 의미합니다.
      </li>
      <li>
        8. 유료서비스(또는 유료상품): 회사가 제공하는 옵션 서비스로, 회원이 추가
        비용을 지불하고 이용할 수 있는 서비스를 말합니다.
      </li>
    </ul>
    <h3 class="title">제3조 (약관의 효력 및 변경)</h3>
    <p class="contents">
      본 약관은 서비스를 이용하고자 하는 모든 회원에게 그 효력을 발생합니다.
    </p>
    <p class="contents">
      본 약관은 회원이 서비스 가입 시 열람할 수 있으며, 회사는 회원이 원할 때
      언제든지 약관을 열람할 수 있도록 인터넷 홈페이지 또는 서비스 화면에
      게시합니다.
    </p>
    <p class="contents">
      회사는 “약관의 규제에 관한 법률”, “전자상거래 등에서의 소비자보호에 관한
      법률”, “정보통신망 이용촉진 및 정보보호”, “온라인 디지털콘텐츠산업
      발전법”, “소비자기본법” 등 관련법에 위배되지 않는 범위 내에서 본 약관을
      개정할 수 있습니다.
    </p>
    <p class="contents">
      회사는 필요하다고 인정되는 경우 본 약관을 변경할 수 있으며, 약관을 변경할 
      경우에는 적용일자, 변경사유를 명시하여 적용일자 14일 전부터 공지합니다.
      다만, 변경할 약관이 회원에게 불리할 때에는 해당 내용을 적용일자 30일
      전부터 공지하며, 이메일 등으로 회원에게 개별적으로 통지합니다. (회원의
      연락처 미기재, 변경 등으로 회원에게 해당 내용을 개별통지 하기가 어려우면
      “홈페이지”에 변경 약관을 공지하는 것으로 개별 통지를 대신합니다.)
    </p>
    <p class="contents">
      회사가 제3항에 따라 개정약관을 공지 또는 통지하면서, 회원에게 약관 변경
      적용일까지 거부의사를 표시하지 아니할 경우, 약관의 변경에 동의한 것으로
      간주한다는 내용을 공지 또는 통지하였음에도 회원이 명시적으로 약관 변경에
      대한 거부의사를 표시하지 아니하면, 변경 약관에 동의한 것으로 간주합니다.
    </p>
    <p class="contents">
      회원은 변경된 약관에 동의하지 아니하는 경우 서비스의 이용을 중단하고
      이용계약을 해지할 수 있습니다.
    </p>
    <p class="contents">
      회원은 약관의 변경에 대하여 주의의무를 다하여야 하며, 회사가 약관의 변경
      시 본 조에 따른 조치를 하였음에도 불구하고 회원이 개정 약관을 인지하지
      못하여 발생하는 손해에 대해 회사는 책임을 지지 않습니다.
    </p>
    <h3 class="title">제4조 (약관 외 준칙)</h3>
    <p class="contents">
      본 약관에 기재되지 않은 사항은 정보통신망 이용촉진 및 정보보호에 관한
      법률(이하 “정보통신망법”), 전기통신기본법, 전기통신사업법 등 관계 법령 및
      회사가 정한 본 서비스의 세부이용지침 등의 규정을 따릅니다.
    </p>
    <p class="contents">
      회사는 필요하면 본 서비스 이용과 관련된 세부이용지침을 정하여 이를 제3조의
      방법으로 공지할 수 있습니다.
    </p>
    <p class="contents">
      본 약관과 관련하여 회사의 정책변경, 법령의 제ㆍ개정 또는 공공기관의 고시나
      지침 등에 따라 회사가 “홈페이지”의 공지사항 게시판 등에 공지하는 내용도
      이용계약의 일부를 구성합니다.
    </p>
    <hr/>
    <h2>제2장 서비스 이용 계약 및 유료상품 구매 계약</h2>
    <h3 class="title">제5조 (이용계약의 성립)</h3>
    <p class="contents">
      이용계약은 회원가입 신청자가 본 약관 및 "개인정보처리방침"에
      "동의합니다"를 선택하고, 회사가 정한 신청양식을 작성한 후 서비스의 이용을
      신청하면 회사가 이를 승낙함으로써 체결됩니다.
    </p>
    <p class="contents">
      회사는 가입신청을 완료하였을 때에는 필요한 사항을 확인한 후 지체 없이 이를
      승낙 하여야 합니다.
    </p>
    <p class="contents">
      회원가입 신청자가 전체 항목에 "동의합니다"를 선택하고 신청양식을 작성하는
      것은 본 약관 및 "개인정보처리방침"의 내용을 숙지하고, 회사가 서비스 이용을
      위해 운영하는 각종 정책과 수시로 공지하는 사항을 준수하는 것에 대해
      동의하는 것으로 봅니다.
    </p>
    <p class="contents">
      회사와 회원간 유료서비스 이용계약은 회원의 “유료 상품 구매 신청”에 대하여
      회사가 이를 승낙하고 회사의 승낙이 회원에게 도달한 시점(유료서비스의
      “구매/결제완료 등”의 표시가 회원에게 절차상 표시된 시점)에 성립합니다.
    </p>
    <h3 class="title">제6조 (이용계약의 유보 및 거절)</h3>
    <p class="contents">
      회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에
      이용계약을 해지할 수 있습니다.
    </p>
    <ul>
      <li>1. 가입신청서의 내용을 허위로 기재한 경우</li>
      <li>2. 다른 사람의 이메일 인증을 수행하는 경우</li>
      <li>
        3. 가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는
        경우, 단 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함
      </li>
      <li>
        4. 회원의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을
        위반하며 신청하는 경우
      </li>
    </ul>
    <p class="contents">
      이용계약 신청에 있어 회사는 전문기관을 통한 실명확인 및 본인인증을 요청할
      수 있습니다.
    </p>
    <p class="contents">
      회사는 아래 각 호에 해당하는 경우에는 회원등록의 승낙을 유보할 수
      있습니다.
    </p>
    <ul>
      <li>1. 제공서비스 설비용량에 현실적인 여유가 없는 경우</li>
      <li>2. 서비스를 제공하기에는 기술적으로 문제가 있다고 판단되는 경우</li>
      <li>3. 회사가 재정적, 기술적으로 필요하다고 인정하는 경우</li>
      <li>4. 기타 귀책사유로 이용승낙이 곤란한 경우</li>
    </ul>
    <p class="contents">
      본 조항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는
      원칙적으로 이를 가입신청자에게 알립니다.
    </p>
    <p class="contents">
      이용계약의 성립 시기는 회사가 가입완료를 신청절차 상에서 표시한 시점으로
      합니다.
    </p>
    <h3 class="title">제7조 (회원의 관리 책임)</h3>
    <p class="contents">
      회원은 서비스 이용을 위한 아이디, 비밀번호의 관리에 대한 책임 등 회원의
      고의ㆍ과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다. 단,
      이것이 회사의 고의ㆍ과실로 인하여 야기된 경우는 회사가 책임을 부담합니다.
    </p>
    <p class="contents">
      회원은 아이디가 제3자가 사용하고 있음(대여 포함)을 인지한 경우에는 즉시
      본인의 비밀번호를 수정하는 등의 조치를 취하여야 하며, 즉시 이를 회사에
      통보하여 회사의 안내를 따라야 합니다.
    </p>
    <h3 class="title">제8조 (개인정보보호 의무)</h3>
    <p class="contents">
      회사는 서비스를 제공하기 위하여 기본적으로 필요한 아이디(이메일)와
      비밀번호, 이름, 연락처, 회사명을 제외한 어떠한 개인정보도 수집하지
      않습니다.
    </p>
    <p class="contents">
      회사는 서비스 제공과 데이터의 출처 표기를 위해서 비밀번호를 제외한 회원이
      가입 시 입력한 아이디를 사용할 수 있습니다.
    </p>
    <p class="contents">
      회사는 회원이 회원 가입 시 입력한 비밀번호에 대해서 고수준의 암호화를 통해
      회사 및 제3자가 알아낼 수 없도록 철저히 보호하도록 노력합니다.
    </p>
    <p class="contents">
      회사의 “개인정보처리방침”은 서비스에 링크된 다른 웹사이트(회사가 운영하지
      않는 웹사이트를 말합니다. 이하 같습니다)에서는 적용되지 않습니다.
    </p>
    <p class="contents">
      회사는 필요한 경우 이러한 업무의 일부 또는 전부를 회사가 선정한 회사에
      위탁할 수 있으며, 회원정보의 취급 및 관리, 서비스 운영 등에 관한 업무를
      위탁하는 경우에는 “개인정보처리방침”에 공지합니다.
    </p>
    <p class="contents">
      회사는 회원의 귀책사유로 인해 노출된 정보에 대해서 책임을 지지 않으며,
      아래와 같은 경우에는 회원의 정보를 제공할 수 있습니다.
    </p>
    <ul>
      <li>
        1. 회원이 서비스를 이용함에 있어 관련 법률을 위반하여 수사기관이나 기타
        정부 기관으로부터 정보제공을 요청받는 경우
      </li>
      <li>
        2. 회원의 법률위반, 본 서비스 약관위반을 포함하여 부정행위 확인 등
        정보보호 업무를 위해 필요한 경우
      </li>
      <li>3. 기타 법률에 의해 요구되는 경우</li>
    </ul>
    <p class="contents">
      회사는 “정보통신망법” 등 관계 법령이 정하는 바에 따라 회원의 개인정보를
      보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및
      회사의 개인정보처리방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의
      링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다.
    </p>
    <p class="contents">
      회사는 상품 결제를 위하여 필요한 최소한의 정보(이름, 연락처, 회사명,
      주소)를 요구할 수 있으며, 결제 관련된 금융 정보는 저장하지 않습니다.
    </p>
    <h3 class="title">제9조 (유료상품 구매신청)</h3>
    <p class="contents">
      회원이 되고자 하는 자는 회사가 정하는 구매 신청 양식에 따라 필요한 정보를
      기입합니다.
    </p>
    <p class="contents">
      구매 신청자는 타인의 정보를 도용하는 경우 서비스 이용이 제한되거나, 관계
      법령에 따라 처벌받을 수 있습니다.
    </p>
    <p class="contents">
      구매 신청 시 허위 정보를 제공해서는 아니 되며, 허위 정보로 인해 발생하는
      문제에 대하여 회사는 책임지지 않습니다.
    </p>
    <h3 class="title">제10조 (유료상품 구매신청의 승낙과 제한)</h3>
    <p class="contents">
      회사는 제9조의 규정에 의한 구매 신청회원에 대하여 업무 수행상 또는 기술상
      지장이 없는 경우에 원칙적으로 접수 순서에 따라 서비스 이용을 승낙합니다.
    </p>
    <p class="contents">
      회사는 다음 각 호의 어느 하나에 해당하는 경우에 대해서 승낙하지 않거나
      승낙을 유보할 수 있습니다.
    </p>
    <ul>
      <li>1. 운영 원칙에서 정한 비정상 이용에 해당하는 경우</li>
      <li>
        2. 음란물의 배포 전시 및 타인의 저작권을 침해하거나 침해할 가능성이 있는
        경우
      </li>
      <li>
        3. 악성 프로그램 및 버그를 이용하거나 시스템 취약점을 악용하는 등 부정한
        방법을 서비스에 사용한 경우
      </li>
      <li>4. 영리를 추구할 목적으로 본 서비스를 이용하고자 하는 경우</li>
      <li>5. 기타 회사에서 규정한 제반 사항을 위반하여 신청하는 경우</li>
    </ul>
    <h3 class="title">제11조 (유료상품의 종류)</h3>
    <p class="contents">
      유료상품의 종류 및 이용요금 등과 관련된 내용은 각 상품 표시 페이지를 통해
      안내합니다.
    </p>
    <p class="contents">
      회사는 일정 기간 공지를 통하여 유료상품을 수시로 변경하거나 해당 상품의
      판매를 중단할 수 있으며, 신규 상품이나 이벤트 상품을 추가할 수 있습니다
    </p>
    <hr/>
    <h2>제3장 서비스 이용 및 운영</h2>
    <h3 class="title">제12조 (서비스의 제공)</h3>
    <p class="contents">회사는 회원에게 아래와 같은 서비스를 제공합니다.</p>
    <ul>
      <li>1. Wrapsody: 암호화된 문서의 편집 및 자산화 서비스</li>
      <li>2. Wrapsody eCo: 암호화된 문서의 편집 및 공유 서비스</li>
      <li>3. Mind-SAT: 악성메일 모의훈련 및 교육 서비스</li>
      <li>4. Fireside: 보안 메신저 서비스</li>
      <li>5. Fasoo DSP: 통합 데이터 보안 서비스</li>
      <li>6. Fasoo DSPM: 데이터 보안 태세 관리 서비스</li>
    </ul>
    <p class="contents">
      회원은 회사가 이용신청을 승낙한 때부터 서비스를 사용할 수 있습니다. 회사는
      승낙한 때부터 서비스를 개시합니다. 다만, 유료 서비스의 경우 회사가
      요금납입을 확인한 직후부터 사용할 수 있습니다.
    </p>
    <h3 class="title">제13조 (서비스의 이용시간)</h3>
    <p class="contents">
      서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 회사는 서비스를
      일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다.
    </p>
    <p class="contents">
      회사는 서비스의 제공에 필요한 경우 수시점검 및 정기점검을 실시할 수
      있으며, 점검시간은 서비스 제공화면 또는 이메일을 통해 공지한 바에
      따릅니다.
    </p>
    <h3 class="title">제14조 (서비스 및 유료상품 변경/중지와 이용 제한)</h3>
    <p class="contents">
      회사는 변경될 서비스의 내용 및 제공일자를 제20조에서 정한 방법으로
      회원에게 이를 통지하고 서비스를 변경하여 제공할 수 있습니다.
    </p>
    <p class="contents">
      회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나
      중지할 수 있고 제20조에서 정한 방법으로 회원에게 통지합니다. 다만, 회사가
      통제할 수 없는 사유로 인한 서비스의 중단(운영자의 고의ㆍ과실이 없는 디스크
      장애, 시스템 다운 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지
      아니합니다.
    </p>
    <ul>
      <li>1. 회원이 회사의 영업활동을 방해하는 경우</li>
      <li>
        2. 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
      </li>
      <li>
        3. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을
        경우
      </li>
      <li>
        4. 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에
        지장이 있는 경우
      </li>
      <li>
        5. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이
        부적당하다고 인정하는 경우
      </li>
      <li>6. 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</li>
    </ul>
    <p class="contents">
      회사는 서비스의 변경, 중지로 발생하는 문제에 대해서는 어떠한 책임도 지지
      않습니다.
    </p>
    <p class="contents">
      회사는 회원이 본 약관을 위반한 경우 경고, 일시적 이용정지, 영구적 이용정지
      등의 단계로 서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.
    </p>
    <p class="contents">
      회원은 서비스 이용정지 기타 서비스 이용과 관련된 이용제한에 대해 회사가
      정한 절차에 따라 이의신청을 할 수 있으며, 회사는 회원의 이의신청이
      정당하다고 판단되는 경우 즉시 서비스 이용을 재개합니다.
    </p>
    <p class="contents">
      사업 종목의 전환, 사업의 포기, 업체 간 통합, 품절 등의 이유로 유료상품을
      제공할 수 없게 되면 회사는 서비스 이용약관에서 정한 방법으로 이용자에게
      통지하고 애초 회사에서 제시한 조건으로 회원에게 보상합니다.
    </p>
    <p class="contents">
      유료상품에 대한 변경 사항은 회사가 해당 유료상품을 제공받거나 신청한
      이용자에게 통지합니다. 이때, 회사는 상품 제공을 중지하거나 계약을 해지할
      수 있으며, 환불 등은 각 유료상품 요금 환불 절차에 따라 진행하며,
      잔여일수에 비례한 유료상품 대금 청구를 중지하거나 해지일로부터 3영업일
      이내에 해당 대금을 환급합니다. 회사가 회원에게 대금의 환급을 지연한 때에는
      그 지연기간에 “전자상거래 등에서의 소비자보호에 관한 법률 시행령”이 정하는
      지연이자율을 곱하여 산정한 지연이자를 지급합니다.
    </p>
    <p class="contents">
      유료 상품을 추가 구매할 경우 기존 구매 상품의 구독이 끝나는 시점까지 일할
      계산되어 청구되며, 구독 갱신 시점에 통합 청구됩니다.
    </p>
    <h3 class="title">제15조 (서비스 해지 및 환불)</h3>
    <p class="contents">
      회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 사이트 내에
      해지신청(탈퇴신청) 메뉴 또는 해지방법에 대한 안내를 통해 해지를 신청할 수
      있습니다.
    </p>
    <p class="contents">
      회사는 등록 해지신청이 접수되면 회원이 원하는 시점 이전에 해당 회원의
      서비스 이용을 해지하여야 합니다.
    </p>
    <p class="contents">
      회원이 계약을 해지할 경우, 관련법 및 개인정보처리방침에 따라 회사가
      회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는
      소멸됩니다.
    </p>
    <p class="contents">
      회사는 아래 각호에 해당하는 경우에 회원과의 이용계약을 해지할 수 있습니다.
    </p>
    <ul>
      <li>1. 회원이 파산, 회생절차를 신청하였거나, 절차가 개시된 경우</li>
      <li>
        2. 회원 또는 멤버가 서비스를 불법적인 용도로 사용하였거나, 불법 정보를
        유통한 경우
      </li>
      <li>
        3. 회원이 본 부속 약관을 포함한 서비스 이용약관을 위반하고 회사의
        시정요청을 영업일 5일 이내에 이행하지 않은 경우
      </li>
    </ul>
    <p class="contents">
      회원은 유료 서비스의 이용에 관한 계약을 체결한 날로부터 7일 이내에 청약을
      철회할 수 있으며, 유료 서비스의 내용이 표시·광고의 내용과 다르거나 계약
      내용과 다르게 이행된 경우에는 유료 서비스를 공급받은 날로부터 3개월 이내
      또는 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약을 철회할 수
      있습니다. 이 경우 회원은 청약 철회를 위해 유료 서비스의 이용으로부터 얻은
      이익에 해당하는 금액을 회사에 지불하여야 합니다.
    </p>
    <p class="contents">
      회원이 유료 서비스를 월간 구독으로 이용하고 있고 잔여 사용기간이 있음에도
      이용 계약을 해지하는 경우, 회사는 월 구독이 끝나는 시점까지 서비스를
      제공하고 추가 결제를 진행하지 않습니다. 회사는 계약 체결 후 7일 이내
      청약의 철회가 아닌 경우 월간 구독 회원의 계약 해지에 따른 환불을 진행하지
      않습니다.
    </p>
    <p class="contents">
      회원이 유료 서비스를 연간 구독으로 이용하고 있고 잔여 사용기간이 있음에도
      불구하고 이용 계약을 해지하는 경우, 회사는 최초 계약을 체결한 일자로부터
      월간 구독 형태로 변환하여 남은 기간에 대한 서비스 제공 및 환불 절차를
      진행합니다. 회사는 최초 계약일을 기준으로 하여 현재 달의 해당 일자가
      지나지 않은 경우 해당일 -1일까지 서비스를 제공합니다. 현재 달의 해당
      일자가 지난 경우 익월 해당 일자까지 서비스를 제공합니다. 회사는 회원이
      결제한 금액에서 서비스를 이용한 기간만큼 월간 구독 이용료를 차감하고 남은
      금액을 환불합니다. 연간 구독의 경우 서비스 개시일 후 10개월이 지난
      시점에는 계약 해지에 따른 환불이 발생하지 않습니다.
    </p>
    <p class="contents">
      회원이 서비스 이용계약을 해지할 경우, 회원을 포함한 멤버의 모든 데이터는
      30일 동안의 유예 기간 이후에 삭제됩니다. 회원은 서비스 이용계약 해지 전
      회원 및 멤버의 데이터를 스스로 백업하여야 하며, 회원이 데이터를 백업하지
      않아 발생한 문제에 대해 회사는 책임을 부담하지 않습니다. 회사는 회원을
      포함한 멤버의 데이터를 관련 법령 및 개인정보처리방침에서 정한 기간 동안
      보유할 수 있습니다.
    </p>
    <h3 class="title">제16조 (정보의 제공 및 광고의 게재)</h3>
    <p class="contents">회원은 서비스 이용 시 노출되는 광고 게재에 대해 동의합니다.</p>
    <p class="contents">회사는 서비스 사용자를 대상으로 광고를 제공할 수 있습니다.</p>
    <p class="contents">
      회원이 서비스상에 광고를 이용하거나 서비스를 통한 광고주의 판촉활동에
      참여하는 등의 방법으로 교신 또는 거래를 하는 것은 전적으로 회원과 광고주
      간의 문제입니다.
    </p>
    <p class="contents">
      회원과 광고주간에 분쟁, 기타 문제가 발생하는 경우, 회원과 광고주가 직접
      해결하여야 하며, 이와 관련하여 회사는 어떠한 책임도 지지 않습니다.
    </p>
    <h3 class="title">제17조 (게시물의 저작권)</h3>
    <p class="contents">
      회사는 게시한 회원의 동의 없이 게시물을 다른 목적으로 사용할 수 없습니다.
    </p>
    <p class="contents">
      회사는 회원이 서비스 내에 게시한 게시물이 타인의 저작권, 기타 권리를
      침해하더라도 이에 대한 민ㆍ형사상의 책임을 부담하지 않습니다. 만일 회원이
      타인의 저작권 기타 권리를 침해하였음을 이유로 회사가 타인으로부터
      손해배상청구 등 이의제기를 받은 경우, 회원은 회사의 면책을 위하여
      노력하여야 하며, 회원은 그로 인해 회사에 발생한 모든 손해를 부담하여야
      합니다.
    </p>
    <p class="contents">
      회사는 회원이 이용계약을 해지하고 사이트를 탈퇴하거나 적법한 사유로 해지된
      경우 30일의 유예기간을 제공 후 해당 회원이 게시하였던 게시물을 삭제할 수
      있습니다.
    </p>
    <hr/>
    <h2>제4장 계약당사자의 의무</h2>
    <h3 class="title">제18조 (회사의 의무)</h3>
    <p class="contents">
      회사는 서비스 제공 및 보안과 관련된 설비를 지속적이고, 안정적인 서비스
      제공에 적합하도록 유지, 점검 또는 복구 등의 조치를 성실히 이행하여야
      합니다.
    </p>
    <p class="contents">
      회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며,
      계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.
    </p>
    <p class="contents">
      회사는 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보보호를 위해
      보안시스템을 갖추어야 하며 “개인정보처리방침”을 공시하고 준수하며, 회원의
      개인정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않고, 이를 보호하기
      위하여 노력합니다.
    </p>
    <p class="contents">
      회사는 서비스이용과 관련하여 회원으로부터 제기된 의견이나 불만이
      정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나
      불만사항에 대해서는 게시판을 활용하거나 이메일 등을 통하여 회원에게 처리
      일정, 과정 및 결과를 전달합니다.
    </p>
    <p class="contents">
      회사가 제공하는 서비스로 인하여 회원에게 손해가 발생한 경우 그러한 손해가
      회사의 고의나 과실에 의해 발생한 경우에 한하여 회사에서 책임을 부담하며,
      그 책임의 범위는 통상손해에 한합니다.
    </p>
    <p class="contents">
      회사는 회원이 수신 동의를 하지 않은 영리 목적의 광고성 이메일 등을
      발송하지 아니합니다.
    </p>
    <p class="contents">
      회사는 “정보통신망 이용촉진 및 정보보호에 관한 법률”, “통신비밀보호법”,
      “전기통신사업법” 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.
    </p>
    <h3 class="title">제19조 (회원의 의무)</h3>
    <p class="contents">회원은 다음 행위를 하여서는 안 됩니다.</p>
    <ul>
      <li>
        1. 다른 회원의 이메일 및 비밀번호를 도용하여 부당하게 서비스를
        이용하거나, 정보를 도용하는 행위
      </li>
      <li>
        2. 타인의 계좌번호 및 신용카드번호 등 타인의 허락 없이 타인의 결제정보를
        이용하여 회사의 유료 서비스를 이용하는 행위
      </li>
      <li>3. 회사가 게시한 정보를 변경하는 행위</li>
      <li>
        4. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등을 송신 또는
        게시하는 행위
      </li>
      <li>5. 회사와 기타 제3자의 저작권 등 지적재산권을 침해하는 행위</li>
      <li>6. 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
      <li>7. 회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위</li>
      <li>
        8. 회사의 직원이나 서비스의 관리자를 가장하거나 사칭하여 또는 타인의
        명의를 도용하여 글을 게시하거나 메일을 발송하는 행위
      </li>
      <li>
        9. 서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는
        컴퓨터 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램 자료를 등록 또는
        유포하는 행위
      </li>
      <li>
        10. 회사가 제공하는 소프트웨어 등을 개작하거나 리버스 엔지니어링,
        디컴파일, 디스어셈블 하는 행위
      </li>
      <li>11. 다른 회원의 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위</li>
      <li>12. 기타 불법적이거나 부당한 행위</li>
    </ul>
    <p class="contents">
      회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항,
      회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는
      행위를 하여서는 아니 됩니다.
    </p>
    <p class="contents">
      회원은 서비스의 이용권한, 기타 서비스 이용계약상의 지위를 타인에게 양도,
      증여할 수 없으며 이를 담보로 제공할 수 없습니다.
    </p>
    <p class="contents">
      회원은 제7조(회원의 관리책임)에서 명시한 비밀번호를 철저히 관리하여야
      합니다. 관리소홀, 부정사용 등에 의하여 발생하는 모든 결과에 대한 책임은
      회원 본인이 부담하며, 회사는 이에 대한 어떠한 책임도 부담하지 않습니다.
    </p>
    <p class="contents">
      민법상 미성년자인 회원이 유료 서비스를 이용할 경우 미성년자인 회원은 결제
      전 법정대리인의 동의를 얻어야 합니다.
    </p>
    <p class="contents">
      회원은 서비스를 이용함에 있어 소속 구성원(이하 “멤버”)의 업무 문서, 메신저 메시지 및 제품 기능에 의해 주기적으로 생성되는 PC 화면 캡처 데이터 등 서비스 내 데이터에 접근, 열람 또는 처리할 수 있으며, 이 경우 관련 법령에 따라 멤버로부터 필요한 모든 동의를 적법하게 획득할 책임이 있습니다. 특히 관리자가 멤버의 PC 화면을 확인하는 기능 등 민감할 수 있는 서비스 이용에 대해서는 반드시 사전에 멤버의 동의를 얻어야 합니다.
    </p>
    <p class="contents">
      회원이 멤버의 동의를 얻지 못하거나 적법한 권한 없이 데이터를 처리하여 발생하는 모든 법적 책임 및 멤버와의 분쟁에 대하여 회사는 어떠한 책임도 지지 않으며, 이에 대한 모든 책임과 분쟁 해결은 회원(고객)의 비용과 책임으로 합니다.
    </p>
    <h3 class="title">제20조 (회원에 대한 통지)</h3>
    <p class="contents">
      회사가 회원에 대한 통지를 하는 경우 본 약관에 별도 규정이 없는 한
      “홈페이지” 공지사항 또는 이메일을 통해 할 수 있습니다.
    </p>
    <p class="contents">
      회사는 불특정 다수 회원에 대한 통지의 경우 “홈페이지” 등에 게시함으로써
      개별 통지에 갈음할 수 있습니다.
    </p>
    <hr/>
    <h2>제5장 크레딧, 손해배상 및 면책, 분쟁 해결</h2>
    <h3 class="title">제21조 (크레딧)</h3>
    <p class="contents">
      크레딧은 회원이 현금과 유사하게 사용할 수 있는 화폐로 손해배상, 이벤트
      프로모션, 서비스 계약 변경에 따른 이용요금 정산 등의 이유로 지급되며
      서비스 이용요금(위약금, 연체료 등의 손해배상금 제외) 지급 시 사용됩니다.
      손해배상 시 유료 서비스 이용을 위해 회사에 납부한 금액을 기준으로
      산정되며, 지급된 크레딧은 양도하거나 현금으로 환불받을 수 없으며,
      발급일로부터 1년간 유효합니다. 단, 프리미엄 요금제의 경우 별도 합의된
      유효기간이 적용됩니다. 이용 중인 사이트를 삭제하거나 계약 해지 시 크레딧은
      소멸되며, 크레딧과 관련된 세부 사항은 회사 정책에 따릅니다.
    </p>
    <h3 class="title">제22조 (SLA 및 손해배상)</h3>
    <p class="contents">
      회사는 서비스 수준 계약(Service Level Agreement, SLA)을 준수하며, 회사의
      귀책 사유로 회사가 월별 가동 시간 비율[해당 월의 총 시간(분)에서 해당 월에
      발생한 중단시간(분)을 뺀 후 해당 월의 총 시간(분)으로 나눈 값]을 99.5%
      이상으로 제공하지 못해 회원이 “유료 상품”을 이용하지 못하는 경우에 한하여,
      회원은 아래에 명시된 기준에 따라 크레딧을 청구할 수 있습니다. 회사는
      회원과 합의하여 확정한 크레딧을 합의한 날의 익월에 회원에게 제공합니다. 한
      달 기준 가동률과 이에 따른 크레딧 비율은 다음과 같습니다.
    </p>
    <ul>
      <li>1. 월간 가동률 99.0% ~ 99.5%: 해당 월 이용요금의 10%</li>
      <li>2. 월간 가동률 95.0% ~ 99.0%: 해당 월 이용요금의 25%</li>
      <li>3. 월간 가동률 95.0% 미만: 해당 월 이용요금의 55%</li>
    </ul>
    <p class="contents">
      서비스 중단은 회원이 서비스에 접속할 수 없는 상태를 의미하며, 중단 시간은
      해당 월 동안 중단이 발생한 시간의 총합으로 산정됩니다. 보상의 지급을 위해
      회원은 서비스 중단이 발생한 시점부터 14일 이내에 청구사유, 청구금액, 및
      산출 근거를 기재하여 고객문의 창구를 통해 제출해야 하며, 이를 이행하지
      않을 경우 보상을 받을 권리를 상실하게 됩니다. 사전 공지를 통해 예정된 정기
      점검 등 제23조 면책사항에 따른 상황의 경우 본 조의 보상 대상에서
      제외됩니다.
    </p>
    <h3 class="title">제23조 (면책사항)</h3>
    <p class="contents">
      회사는 천재지변이나 그와 비슷한 불가항력으로 유료상품을 제공할 수 없게
      된다면 그 제공에 대한 책임이 면제됩니다.
    </p>
    <p class="contents">
      회사는 전기통신서비스 특성상 불가피한 사유로 서비스를 제공할 수 없거나
      관련 설비의 보수, 교체, 정기 및 긴급점검, 공사 등 부득이한 사유로
      일시적으로 서비스를 중단하게 된다면 그것에 대해 책임을 지지 않습니다.
    </p>
    <p class="contents">
      고의, 과실 또는 서비스 이용방법의 미숙지, 공지된 업데이트 미진행 등 회원의
      귀책사유로 말미암아 회원의 서비스 이용에 장애가 발생하고, 회원 정보나
      자료가 소실되는 등 회원에게 손해가 발생했을 때 회사는 책임을 지지
      않습니다.
    </p>
    <p class="contents">
      회원이 신상정보와 이메일 주소를 부실하게 기재하여 손해가 발생했을 때
      회사는 책임을 지지 않습니다.
    </p>
    <p class="contents">
      회사는 회원이 유료상품을 이용하여 기대하는 수익을 상실한 것에 대하여
      책임을 지지 않으며, 그 밖의 유료상품을 통하여 얻은 자료로 손해가 발생했을
      때에도 책임을 지지 않습니다.
    </p>
    <p class="contents">
      회사는 회원이 유료상품을 이용하여 자료를 게시ㆍ전송ㆍ저장ㆍ조회했을 때
      발생하는 법적인 문제에 대해 책임을 지지 않습니다.
    </p>
    <p class="contents">
      회사는 회원 상호 간 또는 회원과 제3자 상호 간에 서비스를 매개로 발생한
      분쟁에 개입할 의무가 없으며 이 때문에 발생한 손해를 배상할 책임도
      없습니다.
    </p>
    <p class="contents">
      회원이 자신의 개인정보를 타인에게 유출 또는 제공하거나, 아이디(ID)와
      비밀번호(PASSWORD)의 분실 및 무단 사용, 관리소홀 등으로 피해가 발생했을 때
      회사는 일절 책임을 지지 않습니다.
    </p>
    <p class="contents">
      회사는 회원의 컴퓨터 오류, 제3자 제공 프로그램의 종료 및 오류, 네트워크
      환경상의 장애 및 오류로 파일이 손상되었거나 업로드 도중에 파일이 잘못
      저장된 것에 대해 책임을 지지 않습니다.
    </p>
    <p class="contents">
      회원상태 변경, 계약만료 또는 요금 미납의 결과로 회원계정이 정지되거나
      보관파일이 삭제되어 회원에게 손해가 발생했을 때 회사는 책임을 지지
      않습니다.
    </p>
    <p class="contents">
      서비스 화면에서 링크, 배너 등으로 연결된 회사(이하 피연결회사)와 회원 간에
      이루어진 거래에 회사는 개입하지 않으며, 해당 거래에 대해 책임을 지지
      않습니다.
    </p>
    <h3 class="title">제24조 (분쟁 조정 및 관할법원)</h3>
    <p class="contents">
      본 약관과 관련하여 회사와 회원 간 발생한 분쟁은 대한민국법을 준거법으로
      합니다. 서비스 이용과 관련하여 발생한 분쟁에 대한 소송을 제기하는 경우에는
      민사소송법 등 관련 법령에 따른 관할법원에 제소합니다.
    </p>
    <hr/>
    <h4 class="subTitle">부칙</h4>
    <p class="contents">[시행일] 본 이용약관은 2026년 06월 01일부터 적용됩니다.</p>
    <p class="contents">– 공고일자 : 2026년 04월 30일</p>
    <p class="contents">– 시행일자 : 2026년 06월 01일</p>
  </body>
</html>
`;

  return (
    <div style={{ fontFamily: "Noto Sans KR" }}>
      <ShadowWrapper htmlContent={htmlContent} />
    </div>
  );
};
export default TermsV20260601;
